import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';

const buildStyle = (
  { backgroundColor, borderColor, depth, font },
  { readingDirection }
) => {
  const boxShadow = depth.boxShadow.hard;
  return {
    caretCommon: {
      base: {
        position: 'absolute'
      }
    },
    caret: {
      position: {
        top: {
          borderLeft: '13px solid transparent',
          borderRight: '13px solid transparent',
          borderTop: `17px solid ${borderColor.base}`,
          top: '100%',
          '&::before': {
            content: '""',
            borderLeft: '12px solid transparent',
            borderRight: '12px solid transparent',
            borderTop: `16px solid ${backgroundColor.base}`,
            position: 'absolute',
            bottom: 1,
            right: -12
          }
        },
        right: {
          borderTop: '13px solid transparent',
          borderBottom: '13px solid transparent',
          borderRight: `17px solid ${borderColor.base}`,
          right: '100%',
          '&::before': {
            content: '""',
            borderTop: '12px solid transparent',
            borderBottom: '12px solid transparent',
            borderRight: `16px solid ${backgroundColor.base}`,
            position: 'absolute',
            left: 1,
            top: -12
          }
        },
        bottom: {
          borderLeft: '13px solid transparent',
          borderRight: '13px solid transparent',
          borderBottom: `17px solid ${borderColor.base}`,
          bottom: '100%',
          '&::before': {
            content: '""',
            borderLeft: '12px solid transparent',
            borderRight: '12px solid transparent',
            borderBottom: `16px solid ${backgroundColor.base}`,
            position: 'absolute',
            top: 1,
            right: -12
          }
        },
        left: {
          borderTop: '13px solid transparent',
          borderBottom: '13px solid transparent',
          borderLeft: `17px solid ${borderColor.base}`,
          left: '100%',
          '&::before': {
            content: '""',
            borderTop: '12px solid transparent',
            borderBottom: '12px solid transparent',
            borderLeft: `16px solid ${backgroundColor.base}`,
            position: 'absolute',
            right: 1,
            top: -12
          }
        }
      }
    },
    largeCaretWrapper: {
      position: {
        top: {
          borderLeft: '29px solid transparent',
          borderRight: '29px solid transparent',
          borderTop: `25px solid ${borderColor.base}`,
          top: '100%',
          '&::before': {
            content: '""',
            borderLeft: '28px solid transparent',
            borderRight: '28px solid transparent',
            borderTop: `24px solid ${backgroundColor.base}`,
            position: 'absolute',
            bottom: 1,
            right: -28
          }
        },
        right: {
          borderTop: '29px solid transparent',
          borderBottom: '29px solid transparent',
          borderRight: `25px solid ${borderColor.base}`,
          right: '100%',
          '&::before': {
            content: '""',
            borderTop: '28px solid transparent',
            borderBottom: '28px solid transparent',
            borderRight: `24px solid ${backgroundColor.base}`,
            position: 'absolute',
            left: 1,
            top: -28
          }
        },
        bottom: {
          borderLeft: '29px solid transparent',
          borderRight: '29px solid transparent',
          borderBottom: `25px solid ${borderColor.base}`,
          bottom: '100%',
          '&::before': {
            content: '""',
            borderLeft: '28px solid transparent',
            borderRight: '28px solid transparent',
            borderBottom: `24px solid ${backgroundColor.base}`,
            position: 'absolute',
            top: 1,
            right: -28
          }
        },
        left: {
          borderTop: '29px solid transparent',
          borderBottom: '29px solid transparent',
          borderLeft: `25px solid ${borderColor.base}`,
          left: '100%',
          '&::before': {
            content: '""',
            borderTop: '28px solid transparent',
            borderBottom: '28px solid transparent',
            borderLeft: `24px solid ${backgroundColor.base}`,
            position: 'absolute',
            right: 1,
            top: -28
          }
        }
      }
    },
    triggerWrapper: {
      base: {
        cursor: 'pointer',
        display: 'inline'
      }
    },
    flyoutWrapper: {
      base: {
        backgroundColor: backgroundColor.base,
        border: `1px solid ${borderColor.base}`,
        boxShadow: `${boxShadow.xOffset} ${boxShadow.yOffset} ${boxShadow.blurRadius} ${boxShadow.spreadRadius} ${boxShadow.color}`,
        color: font.color.base,
        fontFamily: font.base.family,
        fontSize: font.base.size.xxs,
        fontWeight: font.base.weight.regular,
        padding: 0,
        ...readingDirection
      }
    },
    caretFlyoutWrapper: {
      base: {
        padding: 16
      },
      position: {
        top: {
          marginBottom: 19
        },
        right: {
          marginLeft: 19
        },
        bottom: {
          marginTop: 19
        },
        left: {
          marginRight: 19
        }
      }
    },
    largeCaretFlyoutWrapper: {
      base: {
        padding: 24
      },
      position: {
        top: {
          marginBottom: 27
        },
        right: {
          marginLeft: 27
        },
        bottom: {
          marginTop: 27
        },
        left: {
          marginRight: 27
        }
      }
    },
    zIdx: {
      base: {
        zIndex: depth.zIndex[100]
      }
    }
  };
};

const useStyle = (zIndex, largeCaret, noPadding, isRtl) => {
  const {
    caret,
    caretCommon,
    largeCaretWrapper,
    triggerWrapper,
    flyoutWrapper,
    caretFlyoutWrapper,
    largeCaretFlyoutWrapper,
    zIdx
  } = useBuildStyleWithTheme(buildStyle, { isRtl });

  return {
    caret: {
      ...(largeCaret ? largeCaretWrapper.base : caret.base),
      ...caretCommon.base
    },
    caretPosition: {
      ...(largeCaret ? largeCaretWrapper.position : caret.position)
    },
    triggerWrapper: {
      ...triggerWrapper.base
    },
    flyoutWrapper: {
      ...flyoutWrapper.base,
      ...(!noPadding &&
        (largeCaret ? largeCaretFlyoutWrapper.base : caretFlyoutWrapper.base)),
      ...(zIndex ? { zIndex } : zIdx.base)
    },
    flyoutPosition: {
      ...(largeCaret
        ? largeCaretFlyoutWrapper.position
        : caretFlyoutWrapper.position)
    }
  };
};

export default useStyle;
